import { jsx as _jsx } from "react/jsx-runtime";
import { useComponent } from '../../../hooks/useComponent';
import AssetsList from '../../common/AssetsList';
import Container from '../../common/Container';
import SectionState from '../../common/SectionState';
const AssetsListSection = ({ entryId, componentType, nested, }) => {
    var _a;
    const assetsListSection = useComponent(entryId, componentType);
    const props = (_a = assetsListSection === null || assetsListSection === void 0 ? void 0 : assetsListSection.fields) !== null && _a !== void 0 ? _a : {
        disposition: 'Horizontal',
        assets: [],
        width: 0,
        height: 0,
    };
    return (_jsx(SectionState, { children: _jsx(Container, { removeContainer: nested, children: _jsx(AssetsList, Object.assign({}, props)) }) }));
};
export default AssetsListSection;
